import { Group } from '../Group';

export class System extends Group {
  get isFake(): boolean {
    return true;
  }

  get isSystem(): boolean {
    return true;
  }
}
